module.exports = __webpack_public_path__ + "img/section5-parallax3.c3bdd58e.png";